import firebaseConfig from './firebase.config.staging';

export const environment = {
  production: false,
  stage: 'staging',
  googleApiKey: 'AIzaSyBUoTDktOWR71QHDFfmxUiLMLRusMgo5v8',
  firebase: firebaseConfig,
  skiprClientUrl: 'https://stgwww.toretanow.app',
  skiprApiUrl: 'https://staging.toretanow.app',
  scotchApiUrl: 'https://stg-scotch-api.toretanow.app',
  googleMapApiKey: 'AIzaSyBUoTDktOWR71QHDFfmxUiLMLRusMgo5v8',
};
